package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.price_category

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.jetbrains.compose.web.css.px

@Composable
fun PriceCategory(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum
) {
    LaunchedEffect(Unit) {
        event(OptionsEvent.GetPriceLevels)
    }

    val chucnk=if (windowSizeMode==WindowSizeModeEnum.PHONE) 1
        else 2
    Row(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth()
            .autoResponsiveness()
            .borderSetting()
            .borderRadius(Dimen.semiLargeRadius)
            .padding(Dimen.extraLargePadding)
    ) {
        Column(
            modifier = Modifier
                .overflow(Overflow.Auto)
                .fillMaxWidth()
                .fillMaxHeight()
        ) {
            state.priceLevels
                ?.chunked(chucnk)
                ?.take(Constants.requiredPriceCategories)
                ?.forEachIndexed { rowIndex, row ->
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(bottom = Dimen.highLargePadding)
                    ) {
                        row.forEachIndexed { colIndex, item ->
                            val position = (rowIndex * 2) + colIndex

                            CustomEditText(
                                value = item ?: "",
                                marginRight =if (windowSizeMode!=WindowSizeModeEnum.PHONE)
                                    Dimen.largePadding else 0.px,
                                width = Dimen.semiLargeEditTextWidth,
                                onInputChange = { newValue, _ ->

                                },
                                fillMaxWidth = windowSizeMode!=WindowSizeModeEnum.Desktop,
                                marginBottom = 0.px,
                                isRequired = false,
                                label = "${Strings.current().priceCategory} ${position + 1}",
                                onFocusIn = {},
                                onCloseIconClick ={
                                    val newPriceLevels = state.priceLevels.toMutableList().apply {
                                        set(position,null)
                                    }
                                    event(OptionsEvent.UpdatePriceLevels(prices = newPriceLevels))
                                } ,
                                onFocusOut = {
                                    val newPriceLevels = state.priceLevels.toMutableList().apply {
                                        set(position, it)
                                    }
                                    event(OptionsEvent.UpdatePriceLevels(prices = newPriceLevels))
                                },
                            )
                        }
                    }
                }
        }
    }
}